import { translates } from '@/utils';
import * as Yup from 'yup';

export const newCashRegisterSchema = Yup.object().shape({
  initialCash: Yup.string()
    .required(translates['cash-register.open'])
    .typeError(translates['cash-register.open']),
});

export const editCashRegisterSchema = Yup.object().shape({
  initialCash: Yup.string().optional(),
});
